import { Record, List, Map } from 'immutable';

export const ResourceTypes = {
  StoryVideo: 'StoryVideo',
  Songs: 'Songs',
  UnitReader: 'UnitReader',
  PhonicsReader: 'PhonicsReader',
  VocabularyPlayPart1: 'VocabularyPlayPart1',
  VocabularyPlayPart2: 'VocabularyPlayPart2',
  ChallengeReader: 'ChallengeReader',
  PhonicsVideo: 'PhonicsVideo',
};

// Column display order in the table (req #2)
export const ResourceColumnOrder = [
  ResourceTypes.StoryVideo,
  ResourceTypes.Songs,
  ResourceTypes.UnitReader,
  ResourceTypes.PhonicsReader,
  ResourceTypes.VocabularyPlayPart1,
  ResourceTypes.VocabularyPlayPart2,
  ResourceTypes.ChallengeReader,
  ResourceTypes.PhonicsVideo,
];

export const ResourceLabels = {
  [ResourceTypes.StoryVideo]: 'Story Video',
  [ResourceTypes.Songs]: 'Songs',
  [ResourceTypes.UnitReader]: 'Unit Reader',
  [ResourceTypes.PhonicsReader]: 'Phonics Reader',
  [ResourceTypes.VocabularyPlayPart1]: 'Vocabulary Play - Part 1',
  [ResourceTypes.VocabularyPlayPart2]: 'Vocabulary Play - Part 2',
  [ResourceTypes.ChallengeReader]: 'Challenge Reader',
  [ResourceTypes.PhonicsVideo]: 'Phonics Video',
};

export const ResourceStatus = {
  NotStarted: 'NotStarted',
  Completed: 'Completed',
  CompletedLate: 'CompletedLate',
  Expired: 'Expired',
};

export const ResourceDisplayCategory = {
  SingleIcon: 'SingleIcon',
  Progress: 'Progress',
  ChallengeReader: 'ChallengeReader',
};

const PROGRESS_TYPES = [
  ResourceTypes.VocabularyPlayPart1,
  ResourceTypes.VocabularyPlayPart2,
  ResourceTypes.PhonicsVideo,
];

export function getResourceDisplayCategory(resourceType) {
  if (resourceType === ResourceTypes.ChallengeReader) {
    return ResourceDisplayCategory.ChallengeReader;
  }
  if (PROGRESS_TYPES.indexOf(resourceType) !== - 1) {
    return ResourceDisplayCategory.Progress;
  }
  return ResourceDisplayCategory.SingleIcon;
}

export function buildUnitResourcesKey(groupId, unitId) {
  return `${groupId}-${unitId}`;
}

const toNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

const ResourceResultRecord = Record({
  resourceType: undefined,
  status: undefined,
  progress: 0,
  totalProgress: 0,
  extraCount: 0,
  readCount: 0,
  totalBooks: 0,
});

export class ResourceResult extends ResourceResultRecord { }

ResourceResult.create = (data = {}) =>
  new ResourceResult({
    resourceType: data.resourceType,
    status: data.status,
    progress: toNumber(data.progress),
    totalProgress: toNumber(data.totalProgress),
    extraCount: toNumber(data.extraCount),
    readCount: toNumber(data.readCount),
    totalBooks: toNumber(data.totalBooks),
  });

const StudentUnitResourcesRecord = Record({
  studentId: undefined,
  resources: new Map(),
});

class StudentUnitResources extends StudentUnitResourcesRecord { }

StudentUnitResources.create = (data = {}) => {
  const resources = Array.isArray(data.resources) ?
    data.resources.reduce(
        (map, resource) => map.set(resource.resourceType, ResourceResult.create(resource)),
        new Map()
      ) :
    new Map();

  return new StudentUnitResources({
    studentId: data.studentId,
    resources,
  });
};

export function toStudentUnitResourcesList(payload) {
  const students = (payload && payload.students) || [];
  if (! Array.isArray(students)) {
    return new List();
  }
  return new List(
    students
      .filter((student) => student && student.studentId != null)
      .map(StudentUnitResources.create)
  );
}

export default StudentUnitResources;



// WEBPACK FOOTER //
// ./data/UnitResources/model.js